import React, { useState, useEffect, useContext } from 'react'
import { Form, Toast } from 'antd-mobile';
import { UserContext } from 'utils/getContext'
import dayjs from 'dayjs'
import moment from 'moment';
import { onSubmitForm } from "api/api";
import { seekJobPage1, seekJobPage2, seekJobPage3 } from 'data/seekJobForm';
import { getAreaObj, getFJJobWantedObj, getUserObj, getSkillObj } from 'utils/getData'
import { judgeSex, userInfoHide, idCardHide } from "utils/ruleType";
import { GetFormType } from "./GetFormType";
import { FromSteps } from "./FromSteps";

/** 我要就业 */
export function SeekJob() {
  const myContext = useContext(UserContext)
  const { userInfo } = myContext
  const { name, sex, idNum, birthday, USER_MOBILE } = userInfo ? userInfo : {}
  const [form] = Form.useForm();
  const [postData, setPostData] = useState({})
  const [content, setContent] = useState({});
  const [stepNum, setStepNum] = useState(1)
  // const [cityContent, setCityContent] = useState([])
  const [areaContent, setAreaContent] = useState([])
  const [jobWantContent, setJobWantContent] = useState([])
  const [skillContent, setSkillContent] = useState([])
  const [formId, setFormId] = useState('');
  const pageData = [seekJobPage1, seekJobPage2, seekJobPage3]
  // const [files, setFiles] = useState([]);
  const title = ['申报信息', '求职意向', '个人经历', '提交申请']

  /** 对默认返回的参数进行处理后显示到页面上 */
  useEffect(() => {
    const newNowDate = new Date();
    const year = newNowDate.getFullYear();
    const month = newNowDate.getMonth() + 1;
    const day = newNowDate.getDate();
    const nowDate = (`${year}-${month}-${day}`);
    if (userInfo) {
      form.setFieldsValue({
        FNAME: idCardHide(name, 1, name.length - 1) || '',
        FIDNUM: userInfoHide(userInfo) || '',
        FSEX: judgeSex(sex),
        FBIRTH: new Date(birthday) || null,
        FPHONUM: USER_MOBILE || '',
        FDay: new Date(nowDate),
      });
    }
  }, [sex, name, form, userInfo, idNum, USER_MOBILE, birthday]);

  /** 获取表单ID */
  useEffect(() => {
    const date = dayjs().format('YYYYMMDDHHmmss');
    setFormId(date + guid());
  }, []);

  /** 获取表单ID */
  function guid() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      // eslint-disable-next-line no-bitwise
      const r = Math.random() * 16 | 0;
      // eslint-disable-next-line no-bitwise
      // eslint-disable-next-line no-mixed-operators
      const v = c === 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }

  /** 初始化数据 */
  useEffect(() => {
    // getCityTreeObj()
    getAreaObj('', areaContent, setAreaContent)
    getFJJobWantedObj('', jobWantContent, setJobWantContent)
    getSkillObj('', '', skillContent, setSkillContent)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  /** 更新提交表单接口参数数据 */
  function setFormInfo(name, value) {
    const newPostData = { ...postData }
    newPostData[name] = value
    if (name === 'FBIRTH') {
      form.setFieldsValue({
        FBIRTH: new Date(value),
      });
    }
    setPostData(newPostData)
  }
  /** 提交表单 */
  async function handleSubmitFormClick(setLoading) {
    if (stepNum < title.length - 1) {
      setStepNum(stepNum + 1)
    }
    if (stepNum === title.length - 1) {
      setLoading(true)
      const formData = await form.validateFields();
      const newNowDate = new Date();
      const year = newNowDate.getFullYear();
      const month = newNowDate.getMonth() + 1;
      const day = newNowDate.getDate();
      const nowDate = (`${year}-${month}-${day}`);
      const postObjective = postData.FOBJECTIVE

      const params = {
        serviceId: 118,
        params: {
          T_PSM_JobInfo: {
            ...postData,
            FNAME: name ? name : postData?.FNAME,
            FIDNUM: idNum ? idNum : postData?.FIDNUM,
            FSEX: sex,
            FPHONUM: postData.FPHONUM ? postData.FPHONUM : USER_MOBILE,
            FBIRTH: postData.FBIRTH ?
              moment(postData.FBIRTH).format('YYYY-MM-DD') : birthday,
            FWORKTIME: formData.FWORKTIME ?
              moment(formData.FWORKTIME).format('YYYY-MM-DD') : postData?.FWORKTIME,
            FDay: formData.FDay ? moment(formData.FDay).format('YYYY-MM-DD') : nowDate,
            FDataSource: 2, // 数据来源字段，固定值
            FCAREOBJCITY: postObjective ? postObjective[0]['FCAREOBJCITY'] : '',
            FCAREOBJCOUN: postObjective ? postObjective[0]['FCAREOBJCOUN'] : '',
            SUBTAB: [
              { T_PSM_JobInfo_FOBJECTIVE: postData.FOBJECTIVE ? [...postData?.FOBJECTIVE] : [] },
              { T_PSM_JobInfo_FWORKEXPER: postData.FWORKEXPER ? [...postData?.FWORKEXPER] : [] },
              { T_PSM_JobInfo_FEDUEXPER: postData.FEDUEXPER ? [...postData?.FEDUEXPER] : [] },
              { T_PSM_JobInfo_FCERTIFICATE: postData.FCERTIFICATE ? [...postData?.FCERTIFICATE] : [] },
            ],
          }
        },
      };
      // 删除指定字段
      delete params.params.T_PSM_JobInfo.FCERTIFICATE
      delete params.params.T_PSM_JobInfo.FEDUEXPER
      delete params.params.T_PSM_JobInfo.FWORKEXPER
      delete params.params.T_PSM_JobInfo.FOBJECTIVE
      try {
        const res = await onSubmitForm(params);
        if (res.code === 200) {
          setStepNum(stepNum + 1)
        } else {
          Toast.show({
            icon: 'fail',
            content: '提交失败，请检查内容并重试',
          })
        }
      } catch (error) {
        Toast.show({
          icon: 'fail',
          content: '提交失败，请检查内容并重试',
        })
      } finally {
        setLoading(false)
      }
    }
  }

  /** 初始化表单渲染模板 */
  const getType = (arr, index) =>
    <GetFormType
      key={index}
      item={arr}
      setFormInfo={setFormInfo}
      content={content}
      setContent={setContent}
      getUserObj={getUserObj}
      //cityContent={cityContent}
      areaContent={areaContent}
      setAreaContent={setAreaContent}
      jobWantContent={jobWantContent}
      setJobWantContent={setJobWantContent}
      skillContent={skillContent}
      setSkillContent={setSkillContent}
      formId={formId}
      form={form}
      postInfo={postData}
      //setFiles={setFiles}
      //getCityTreeObj={getCityTreeObj}
      getAreaObj={getAreaObj}
      getJobWantedObj={getFJJobWantedObj}
      getSkillObj={getSkillObj}
    />
  return (
    <FromSteps
      stepNum={stepNum}
      title={title}
      getType={getType}
      setStepNum={setStepNum}
      form={form}
      pageData={pageData}
      handleSubmitFormClick={handleSubmitFormClick}
    />
  )
}